export const accessMessages: Record<string, string> = {
  workspace_blocked: 'Пространство заблокировано. Обратитесь к администратору сервиса.',
  subscription_expired: 'Срок подписки закончился. Продлите доступ в кабинете S-A-S Forms.',
  subscription_not_started: 'Назначенный период доступа ещё не начался.',
  subscription_missing: 'Для пространства не назначен период доступа.',
  feature_unavailable: 'Эта возможность не входит в текущий тариф.',
  form_limit_reached: 'Достигнут лимит сохранённых форм. Архивные формы тоже входят в лимит.',
  active_form_limit_reached: 'Достигнут лимит опубликованных форм.',
  form_archived: 'Форма находится в архиве. Сначала восстановите её.',
  form_not_published: 'Форма ещё не опубликована.',
  publication_disabled: 'Публикация выключена.',
  publication_required: 'Для исполнения формы выберите включённую публикацию.',
}

export function describeApiDetail(detail: any): string {
  if (typeof detail === 'string') return detail === 'LOGIN_BAD_CREDENTIALS' ? 'Неверный email или пароль.' : detail
  if (Array.isArray(detail)) return detail.map(item => item.msg || item.message || String(item)).join('\n')
  if (detail?.code && accessMessages[detail.code]) return accessMessages[detail.code]
  if (detail?.issues) return detail.issues.map((item: any) => item.message).join('\n')
  if (detail?.fields) return Object.entries(detail.fields).map(([key, value]) => key + ': ' + value).join('\n')
  return detail?.message || detail?.error || 'Запрос не выполнен.'
}

export class ApiError extends Error {
  constructor(public status: number, public detail: any) { super(describeApiDetail(detail)); this.name = 'ApiError' }
  get code(): string { return typeof this.detail?.code === 'string' ? this.detail.code : '' }
  get isAccessDenied(): boolean { return this.status === 403 && this.code in accessMessages }
}

export function isAbort(error: unknown): boolean { return error instanceof Error && error.name === 'AbortError' }
